import { render, staticRenderFns } from "./GenerateDocumentForOrderModal.vue?vue&type=template&id=b0f64374&scoped=true&"
import script from "./GenerateDocumentForOrderModal.vue?vue&type=script&lang=js&"
export * from "./GenerateDocumentForOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f64374",
  null
  
)

export default component.exports